import React from 'react';
import './Content.scss';

class Content extends React.Component {
    render() {
        return (
            <div id="content">
                {this.props.children}
            </div>
        );
    }
}

export default Content;
